export type ShopItem = {
  title: string;
  category: "Meditasyon" | "Doğal taş" | "Olumlama" | "Ritüel" | "Günlük çalışma";
  description: string;
};

export type ShopBundle = {
  code: number;
  headline: string;
  items: ShopItem[];
};

const SHOP_BY_CODE: Record<number, ShopBundle> = {
  1: {
    code: 1,
    headline: "Kimlik, irade ve sınırlar",
    items: [
      {
        title: "Köklenme + niyet meditasyonu",
        category: "Meditasyon",
        description:
          "3 dakika kök çakra nefesi, ardından tek bir niyet cümlesi seç ve 7 kez tekrar et.",
      },
      {
        title: "Kırmızı jasper",
        category: "Doğal taş",
        description:
          "Kararlılığı ve fiziksel dayanıklılığı destekler; niyet çalışmasıyla birlikte kullanılabilir.",
      },
      {
        title: "Ben başlatırım",
        category: "Olumlama",
        description:
          "Ben kendi hayatımın lideriyim. Kararları sevgiyle ve netlikle alırım.",
      },
      {
        title: "Sınır ritüeli",
        category: "Ritüel",
        description:
          "Bugün 'hayır' demen gereken 1 şeyi yaz. Ardından 'evet' dediğin değeri yaz.",
      },
    ],
  },
  2: {
    code: 2,
    headline: "İlişkiler, hassasiyet ve denge",
    items: [
      {
        title: "Kalp uyumu meditasyonu",
        category: "Meditasyon",
        description:
          "Kalp alanına nefes gönder. 10 nefes boyunca 'yumuşuyorum' de.",
      },
      {
        title: "Ay taşı",
        category: "Doğal taş",
        description:
          "Duygusal dengeyi ve sezgiyi destekler; özellikle iletişim günlerinde faydalıdır.",
      },
      {
        title: "Ben uyumu seçerim",
        category: "Olumlama",
        description:
          "Ben hem kendimi hem karşımdakini duyuyorum. Uyumla ilerliyorum.",
      },
      {
        title: "İlişki günlüğü",
        category: "Günlük çalışma",
        description:
          "Bugün neyi varsaydım? Ne sorsaydım daha net olurdu? 5 dakika yaz.",
      },
    ],
  },
  3: {
    code: 3,
    headline: "İfade, oyun ve yaratıcılık",
    items: [
      {
        title: "Ses açma çalışması",
        category: "Meditasyon",
        description:
          "3 dakika mırıldanma (humming). Göğüs ve boğaz titreşimini hisset.",
      },
      {
        title: "Sitrin",
        category: "Doğal taş",
        description:
          "Neşe, motivasyon ve yaratıcı akışı destekler; üretim rutiniyle birlikte kullan.",
      },
      {
        title: "Ben kendimi ifade ederim",
        category: "Olumlama",
        description:
          "Benim sesim değerlidir. Kendimi açık, samimi ve yaratıcı şekilde ifade ederim.",
      },
      {
        title: "Yaratıcı 15 dakika",
        category: "Ritüel",
        description:
          "Gün içinde 15 dakika: yazı, çizim, müzik veya hareket; sonucu değil süreci seç.",
      },
    ],
  },
  4: {
    code: 4,
    headline: "Düzen, disiplin ve güven",
    items: [
      {
        title: "Topraklanma meditasyonu",
        category: "Meditasyon",
        description:
          "Ayakta dur, ayak tabanını hisset. Nefesle birlikte ağırlığı yere bırak.",
      },
      {
        title: "Dumanlı kuvars",
        category: "Doğal taş",
        description:
          "Gerginliği azaltmaya ve güven hissini güçlendirmeye yardımcı olur.",
      },
      {
        title: "Ben adım adım ilerlerim",
        category: "Olumlama",
        description:
          "Ben sabırla ve düzenle büyürüm. Küçük adımlar büyük sonuçlar yaratır.",
      },
      {
        title: "3 maddelik plan",
        category: "Günlük çalışma",
        description:
          "Bugün için 3 küçük hedef yaz; sadece birini bile yapman yeterli.",
      },
    ],
  },
  5: {
    code: 5,
    headline: "Özgürlük, değişim ve cesur seçimler",
    items: [
      {
        title: "Hareket meditasyonu",
        category: "Meditasyon",
        description:
          "2 dakika esneme + 2 dakika ritmik nefes. Bedeni özgürleştir.",
      },
      {
        title: "Akuamarin",
        category: "Doğal taş",
        description:
          "İletişimi yumuşatır, değişim dönemlerinde akışa girmeyi destekler.",
      },
      {
        title: "Ben özgür ve güvendeyim",
        category: "Olumlama",
        description:
          "Ben değişim içinde bile güvendeyim. Yeni olana açık ve meraklıyım.",
      },
      {
        title: "Konfor alanı adımı",
        category: "Ritüel",
        description:
          "Bugün küçük bir yenilik seç: farklı bir konuşma, farklı bir alışkanlık.",
      },
    ],
  },
  6: {
    code: 6,
    headline: "Şifa, aile ve kalp sorumluluğu",
    items: [
      {
        title: "Şefkat meditasyonu",
        category: "Meditasyon",
        description:
          "Kendine 'iyi ki varsın' de. Sonra aynı cümleyi sevdiklerine gönder.",
      },
      {
        title: "Pembe kuvars",
        category: "Doğal taş",
        description:
          "Kalp alanını yumuşatır; öz-şefkat ve ilişki iyileştirmede destek olur.",
      },
      {
        title: "Ben sevgiyle sorumluluk alırım",
        category: "Olumlama",
        description:
          "Ben kendi ihtiyaçlarımı da görerek sevgiyle sorumluluk alırım.",
      },
      {
        title: "Ev enerjisi temizliği",
        category: "Ritüel",
        description:
          "Pencere aç, 5 dakika havalandır. Bir köşeyi sadeleştir ve teşekkür et.",
      },
    ],
  },
  7: {
    code: 7,
    headline: "İçsel bilgelik, güven ve teslimiyet",
    items: [
      {
        title: "Sessizlik meditasyonu",
        category: "Meditasyon",
        description:
          "7 dakika: sadece nefesi izle. Düşünce geldiğinde nazikçe geri dön.",
      },
      {
        title: "Ametist",
        category: "Doğal taş",
        description:
          "Zihni sakinleştirmeye ve sezgiyi güçlendirmeye yardımcı olur.",
      },
      {
        title: "Ben iç sesime güvenirim",
        category: "Olumlama",
        description:
          "Benim sezgim bana yol gösterir. Gerekli bilgi doğru zamanda gelir.",
      },
      {
        title: "Soru listesi",
        category: "Günlük çalışma",
        description:
          "Bugün 3 soru yaz: Ne biliyorum? Ne bilmiyorum? Ne sormaya hazırım?",
      },
    ],
  },
  8: {
    code: 8,
    headline: "Bolluk, değer ve liderlik",
    items: [
      {
        title: "Bolluk nefesi",
        category: "Meditasyon",
        description:
          "Nefes alırken 'alıyorum', verirken 'paylaşıyorum' de. 20 nefes.",
      },
      {
        title: "Kaplan gözü",
        category: "Doğal taş",
        description:
          "Odak ve özgüveni destekler; hedef çalışmalarında faydalıdır.",
      },
      {
        title: "Ben değer yaratırım",
        category: "Olumlama",
        description:
          "Ben emeğimin değerini bilirim ve bereketi bilinçle yönetirim.",
      },
      {
        title: "Hedef netleştirme",
        category: "Günlük çalışma",
        description:
          "Bu ayın tek hedefini yaz. Başarı kriterini ve ilk küçük adımı belirle.",
      },
    ],
  },
  9: {
    code: 9,
    headline: "Tamamlama, affediş ve hizmet",
    items: [
      {
        title: "Bırakma meditasyonu",
        category: "Meditasyon",
        description:
          "Nefes verirken 'bırakıyorum' de. Omuzlardan yüklerin akıp gittiğini hayal et.",
      },
      {
        title: "Labradorit",
        category: "Doğal taş",
        description:
          "Dönüşüm dönemlerinde koruyucu bir alan hissi verir, enerjiyi dengeler.",
      },
      {
        title: "Ben tamamlar ve serbest bırakırım",
        category: "Olumlama",
        description:
          "Ben geçmişi sevgiyle kapatırım. Hayatımda yeniye yer açıyorum.",
      },
      {
        title: "Affetme mektubu",
        category: "Ritüel",
        description:
          "Göndermeden bir mektup yaz: duygu, ihtiyaç, ders. Sonunda teşekkür et.",
      },
    ],
  },
};

export function getShopBundleForCode(code: number): ShopBundle {
  return SHOP_BY_CODE[code] ?? SHOP_BY_CODE[1];
}

export function buildShopForCodes(codes: number[]): ShopBundle[] {
  const unique = Array.from(
    new Set((codes ?? []).filter((n) => Number.isFinite(n) && n >= 1 && n <= 9)),
  ) as number[];

  if (unique.length === 0) {
    return [
      {
        code: 0,
        headline: "Dengede kalma",
        items: [
          {
            title: "Günlük denge meditasyonu",
            category: "Meditasyon",
            description:
              "3 dakika nefes + 3 dakika şükür. Bugün iyi giden 3 şeyi hatırla.",
          },
          {
            title: "Şeffaf kuvars",
            category: "Doğal taş",
            description:
              "Netlik ve niyet gücünü destekler; genel denge çalışmalarında kullanılabilir.",
          },
          {
            title: "Ben dengedeyim",
            category: "Olumlama",
            description:
              "Ben enerjimi dengede tutarım. Bugün ihtiyacım olan her şey içimdedir.",
          },
        ],
      },
    ];
  }

  return unique.map((code) => getShopBundleForCode(code));
}
